export default __webpack_public_path__ + "static/media/logistics.9b2730d4.svg";